import React from 'react'
import Countdown from 'react-countdown'
import moment from 'moment'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import constants from 'helpers/constants'
import { useStartTime } from 'hooks'
import countdownRenderer from './countdownRenderer'

const {
  EVENT_CONSTANTS: { STATUS },
} = constants

const EventTime = ({ startTime, status, classNames, onComplete }) => {
  const { formattedDate, startTimeMilliseconds, isBefore24Hours } = useStartTime(startTime)

  return (
    <div className={classnames('flex flex-col justify-center', classNames.wrapper)}>
      {isBefore24Hours ? (
        <Countdown
          date={startTimeMilliseconds}
          renderer={countdownRenderer(classNames.countdown)}
          onComplete={onComplete}
        />
      ) : (
        status === STATUS.STARTED && (
          <span className={classnames('text-white', classNames.startDate)}>
            Started at: {moment(startTime).format('hh:mm A')}
          </span>
        )
      )}
      <span className={classnames('text-white opacity-50', classNames.date)}>{formattedDate}</span>
    </div>
  )
}

EventTime.propTypes = {
  startTime: PropTypes.string,
  status: PropTypes.string,
  classNames: PropTypes.shape({
    wrapper: PropTypes.string,
    countdown: PropTypes.string,
    date: PropTypes.string,
  }),
  onComplete: PropTypes.func,
}

export default EventTime
